import React from 'react'
import useFetch from '../hooks/useFetch'
import '../../config/i18n'
import useMultilineTextUrl from '../hooks/useMultilineTextUrl'

export default function MultilineText ({
    localizationKey,
    className = 'adobe-easybake-multiline-text'
}) {
    const url = useMultilineTextUrl(localizationKey)
    const html = useFetch({ url, defaultValue: '', json: false })

    return (
        <React.Fragment>
            {html &&
                <p className={className} dangerouslySetInnerHTML={{ __html: html }}></p>
            }
        </React.Fragment>
    )
}
